export default __webpack_public_path__ + "static/hands-ded4ed039ef31046eb938626e4760e87.svg";